<template>
  <div class="base-search-input">
    <exc-base-input
      ref="input"
      v-model="search"
      class="base-search-input__input"
      v-bind="$attrs"
      :placeholder="placeholder"
    />
    <transition name="fade" mode="out-in">
      <search-icon
        class="base-search-input__icon base-search-input__icon--search txt--theme-06"
        @click="focusOnInput"
      />
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { ExcBaseInput } from '@/components/common'

export default {
  name: 'BaseSearchInput',

  components: {
    SearchIcon: () =>
      import(/* webpackMode: "eager" */ '@/assets/icons/search.svg?inline'),
    ExcBaseInput,
  },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
  },

  computed: {
    search: {
      get () {
        return this.value
      },
      set: debounce(function (val) {
        this.emitValue(val)
      }, 500),
    },
  },

  methods: {
    focusOnInput () {
      const { input } = this.$refs
      if (input) input.$el.focus()
    },

    emitValue (val = '') {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.base-search-input {
  position: relative;

  &::v-deep {
    input.exc-base-input {
      background: color(color-01);
      padding: 0 toRem(50px) 0 toRem(18px);
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 100%;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    padding: 0;

    &:hover {
      cursor: pointer;
    }

    &--clear {
      padding: 1rem;
    }

    &--search {
      padding: toRem(10px);
      width: auto;
      height: 100%;
    }
  }
}
</style>
